import { Checkbox } from '@/components/ui/daisy';

type ScheduledLessonPlanItemCheckboxProps = {
  hasDone: boolean;
  disabled: boolean;
  onChange: () => void;
};

export default function ScheduledLessonPlanItemCheckbox({
  hasDone,
  disabled,
  onChange,
}: ScheduledLessonPlanItemCheckboxProps) {
  return (
    <Checkbox
      color={hasDone ? 'success' : 'default'}
      checked={hasDone}
      disabled={disabled}
      onChange={onChange}
    />
  );
}
